import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/order_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  number_cont: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.number',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'rejected', 'wait_admin_audit', 'admin_rejected', 'wait_boss_audit', 'boss_rejected', 'wait_supplier_confirm', 'confirmed', 'partial', 'completed', 'wait_sales_director_audit', 'wait_supplier_boss_confirm', 'sales_director_rejected', 'supplier_boss_rejected', 'supplier_rejected', 'fabric_arrived', 'cutting_updated', 'printing_in_progress', 'workshop_in_progress', 'tail_in_progress'],
    },
    model_name: 'Order',
    label_key_path: 'order.state',
  },
  state_in: {
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'rejected', 'wait_admin_audit', 'admin_rejected', 'wait_boss_audit', 'boss_rejected', 'wait_supplier_confirm', 'confirmed', 'partial', 'completed', 'wait_sales_director_audit', 'wait_supplier_boss_confirm', 'sales_director_rejected', 'supplier_boss_rejected', 'supplier_rejected', 'fabric_arrived', 'cutting_updated', 'printing_in_progress', 'workshop_in_progress', 'tail_in_progress'],
    },
    model_name: 'Order',
    label_key_path: 'order.state',
  },
  accessory_state_eq: {
    column_type: 'enum',
    extra: {
      options: ['needless', 'pending', 'submited', 'received', 'rejected', 'confirmed', 'need'],
    },
    model_name: 'Order',
    label_key_path: 'order.accessoryState',
  },
  company_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'order.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'Order',
  },
  company: {
    column_type: 'belongs_to',
    label_key_path: 'order.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'Order',
  },
  company_id_in: {
    column_type: 'belongs_to',
    label_key_path: 'order.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'Order',
  },
  creator_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'order.creator',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  creator: {
    column_type: 'belongs_to',
    label_key_path: 'order.creator',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  sales_directors_id_eq: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.salesDirectorsIdEq',
  },
  merchandiser_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'order.merchandiser',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  merchandiser: {
    column_type: 'belongs_to',
    label_key_path: 'order.merchandiser',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  product_style_number_cont: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.styleNumber',
  },
  product_style_number_cont_any: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.styleNumber',
  },
  id_in: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.id',
  },
  supplier_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'order.supplier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  supplier: {
    column_type: 'belongs_to',
    label_key_path: 'order.supplier',
    extra: {
      model_name: 'User',
      display_column: 'screen_name',
    },
    model_name: 'Order',
  },
  overdue_state: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.overdueState',
  },
  plan_completed_on_compare_delivery_on: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.planCompletedOnCompareDeliveryOn',
  },
  order_at_gteq: {
    column_type: 'datetime',
    model_name: 'Order',
    label_key_path: 'order.orderAt',
  },
  order_at_lteq: {
    column_type: 'datetime',
    model_name: 'Order',
    label_key_path: 'order.orderAt',
  },
  virtual_warehouse_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'order.virtualWarehouse',
    extra: {
      model_name: 'VirtualWarehouse',
      display_column: 'name',
    },
    model_name: 'Order',
  },
  virtual_warehouse: {
    column_type: 'belongs_to',
    label_key_path: 'order.virtualWarehouse',
    extra: {
      model_name: 'VirtualWarehouse',
      display_column: 'name',
    },
    model_name: 'Order',
  },
  deliveries_state_eq: {
    column_type: 'enum',
    extra: {
      options: ['init', 'delivering', 'reached', 'checked', 'inbounded', 'failed', 'delivered'],
    },
    model_name: 'Delivery',
    label_key_path: 'delivery.state',
  },
  purchase_order_combined_status_eq: {
    model_name: 'PurchaseOrder',
    column_type: 'string',
    label_key_path: 'purchaseOrder.combinedStatus',
  },
  order_accessory_deliveries_state_eq: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.orderAccessoryDeliveriesStateEq',
  },
  is_push_to_jushuitan_eq: {
    column_type: 'boolean',
    model_name: 'Order',
    label_key_path: 'order.isPushToJushuitan',
  },
}
export const formColumnsConfig = {
  'self': {
    'delivery_on': { required: true, disabledUpdate: false },
    'product_id': { required: true, disabledUpdate: true },
    'remark': { required: false, disabledUpdate: false },
    'internal_remark': { required: false, disabledUpdate: false },
    'files': { required: false, disabledUpdate: false },
    'creator_id': { required: false, disabledUpdate: false },
    'supplier_id': { required: false, disabledUpdate: false },
    'customer_level': { required: false, disabledUpdate: false },
    'quality_requirement': { required: false, disabledUpdate: false },
    'virtual_warehouse_id': { required: false, disabledUpdate: false },
    'need_accessory': { required: false, disabledUpdate: false },
    'accessory_reach_on': { required: false, disabledUpdate: false },
    'is_pre_order': { required: false, disabledUpdate: false },
    'line_item_table_attributes': { required: true, disabledUpdate: false },
  },
  'line_item_table_attributes': {
    'quantity': { required: true, disabledUpdate: false },
    'color_option_value_id': { required: true, disabledUpdate: false },
    'size_option_value_id': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Order', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Order', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
